import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VDataFooter from 'vuetify/lib/components/VDataIterator/VDataFooter'
import cs from 'vuetify/es5/locale/cs'
import colors from 'vuetify/lib/util/colors'

VDataFooter.extendOptions.props.itemsPerPageOptions.default = () => [10, 20, 40, 80]

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: {
      cs,
      noDataText: 'Nebyla nalezena žádná data',
    },
    current: 'cs',
  },
  theme: {
    themes: {
      light: {
        primary: '#fe4600',
        secondary: colors.orange.lighten4,
        accent: colors.indigo.base,
      },
    },
  },
})
